import { subscribeToEvent } from '../tools/event-subscribe';

export function readTimeCollector(onChange) {
  const data = [];
  let lastActiveEventTime = Date.now();

  /**
     *
     * @param {Event} e
     */
  function handleActiveEvent() {
    const time = Date.now() - lastActiveEventTime;

    if (time > 2000) {
      data.push(time);
      onChange(time);
    }

    lastActiveEventTime = Date.now();
  }

  const subscriptions = ['click', 'keydown']
    .map(t => subscribeToEvent(window, t, handleActiveEvent, { capture: true }));

  function stop() {
    subscriptions.forEach(s => s());
  }

  function toString() {
    let max = 0,
      min,
      summ = 0,
      avg;
    if (data.length) {
      for (const time of data) {
        if (time > max) max = time;
        if (!min || time < min) min = time;
        summ += time;
      }

      avg = summ / data.length;
    } else {
      max = min = summ = avg = Date.now() - lastActiveEventTime;
    }
    return `${Math.round(max)}|${Math.round(min)}|${Math.round(avg)}`;
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/read-time.js